// ** Third Party Components
import styled, { css } from "styled-components";

export const StyledSvgIconContainer = styled.span`
	svg {
		fill: ${({ theme: { colors } }) => colors.whiteAlways};
		display: inline-block;
		vertical-align: bottom;
		height: 1em;

		${({ customHeight }) =>
			customHeight &&
			css`
				height: ${customHeight};
			`};
	}
`;
const DynamicVolumeIcon = ({ volume, customHeight }) => {
	// Wszystkie SVG w tym komponencie są od nas z plików i nie miały zapisu o licencji.
	return (
		<StyledSvgIconContainer
			style={{ marginLeft: volume > 0 ? "1px" : null }}
			customHeight={customHeight}
		>
			{volume === 0 ? (
				<svg
					aria-hidden="true"
					focusable="false"
					data-prefix="fas"
					data-icon="volume-mute"
					role="img"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 640 512"
				>
					<path d="M633.8 458.1l-69-53.3C592.4 360.8 608 309.7 608 256c0-95.3-47.7-183.6-127.7-236-11.2-7.3-26.2-4.2-33.5 7-7.3 11.2-4.2 26.2 7 33.5 66.3 43.5 105.8 116.6 105.8 195.6 0 42.8-12 83.6-33.2 119.1l-38.1-29.5C503.5 318.7 512 288.1 512 256c0-63.1-32.1-122.1-85.8-156.2-11.2-7.1-26-3.8-33.1 7.4-7.1 11.2-3.8 26 7.4 33.1C440.3 165.6 464 209.4 464 256c0 21.2-5 41.6-14.2 59.9l-39.6-30.6c3.4-9.4 5.8-19.1 5.8-29.3 0-31.9-17.5-61.3-45.8-76.9-11.6-6.3-26.2-2.2-32.6 9.5-6.4 11.6-2.2 26.2 9.5 32.6 11.8 6.5 19.1 18.2 20.4 31.1L288 190.8V88c0-21.5-26-32-41-17l-49.7 49.7L45.5 3.4C38.5-2.1 28.4-.8 23 6.2L3.4 31.5C-2.1 38.4-.8 48.5 6.2 53.9l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-7 4.2-17-2.8-22.5zM32 184v144c0 13.3 10.7 24 24 24h102.1l89 89c15 15 41 4.5 41-17V352.6L43.8 163.8C36.9 168.1 32 175.3 32 184z" />
				</svg>
			) : volume < 0.25 ? (
				<svg
					aria-hidden="true"
					focusable="false"
					data-prefix="fas"
					data-icon="volume-down"
					role="img"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 578 512"
				>
					<path d="M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z" />
				</svg>
			) : volume < 0.5 ? (
				<svg
					aria-hidden="true"
					focusable="false"
					data-prefix="fas"
					data-icon="volume"
					role="img"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 578 512"
				>
					<path d="M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.53 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z" />
				</svg>
			) : (
				volume >= 0.5 && (
					<svg
						aria-hidden="true"
						focusable="false"
						data-prefix="fas"
						data-icon="volume-up"
						role="img"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 578 512"
					>
						<path d="M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z" />
					</svg>
				)
			)}
		</StyledSvgIconContainer>
	);
};

export default DynamicVolumeIcon;
